/**
 * @generated SignedSource<<37f5bc8b6b4d8e11d61b9076a2cb45ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditNewsTickerDefinitionScreen_Query$variables = {
  id: string;
};
export type EditNewsTickerDefinitionScreen_Query$data = {
  readonly node: {
    readonly id?: string;
    readonly " $fragmentSpreads": FragmentRefs<"EditNewsTickerDefinitionForm_MessageDefinitionFragment">;
  } | null | undefined;
};
export type EditNewsTickerDefinitionScreen_Query = {
  response: EditNewsTickerDefinitionScreen_Query$data;
  variables: EditNewsTickerDefinitionScreen_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditNewsTickerDefinitionScreen_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EditNewsTickerDefinitionForm_MessageDefinitionFragment"
              }
            ],
            "type": "NewstickerMessage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditNewsTickerDefinitionScreen_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isActive",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "forwardingUrl",
                "storageKey": null
              }
            ],
            "type": "NewstickerMessage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d16cfa13e64ca51f317fe28b849fd64b",
    "id": null,
    "metadata": {},
    "name": "EditNewsTickerDefinitionScreen_Query",
    "operationKind": "query",
    "text": "query EditNewsTickerDefinitionScreen_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on NewstickerMessage {\n      id\n      ...EditNewsTickerDefinitionForm_MessageDefinitionFragment\n    }\n    id\n  }\n}\n\nfragment EditNewsTickerDefinitionForm_MessageDefinitionFragment on NewstickerMessage {\n  id\n  text\n  isActive\n  forwardingUrl\n}\n"
  }
};
})();

(node as any).hash = "4ae45de5d8eee16198058fd9ffa27622";

export default node;
